// @flow

import { observer } from "mobx-react";
import React from "react";

import "./Overlay.scss";

type Props = {
    onClick?: Function
};

@observer
export default class Overlay extends React.Component<Props> {
    render() {
        return <div className="Overlay" onClick={this.props.onClick} />;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Overlay/Overlay.js